import { ScriptType } from "@/types/ses/sesScriptTypes";
import { ActionForType } from "@/components/ActionEvent/ActionEvent.props";

// функция опеределения типа скрипта по действию
const determineScriptTypeByAction = (actionFor: ActionForType): ScriptType => {
	switch (actionFor.for) {
		case "dataElement":
		case "dataException":
			return "data";
		case "endpoint":
		case "endpointException":
		case "endpointEntry":
			return "endpoint";
		case "robotEvent":
		case "robotException":
			return "endpoint";
		default:
			const defaultScriptType: never = actionFor;
			return defaultScriptType;
	}
};

export default determineScriptTypeByAction;
